export default {
  atDepth: '{valueUnit} at {depth} {depthUnit}',
  time: 'Time',
  temp: 'Temp.',
  nlPerHPerM: 'Flow',
  cAtm: 'Atmosphere',
  cnAtm: 'Atmosphere',
  cd: 'cd',
  retainedAustenite: 'ret. aust. ca.',
  hardnessProfile: 'Hardness',
  modal: {
    header: 'Configuration of carbon table',
    depth: 'Depth',
  },
};
